import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { BackdropLoader, toast } from '@livable/saas-react-components';
import { Alert, Typography } from '@mui/material';
import React, { useState } from 'react';
import { ACHPaymentOptionForm } from 'src/components/settings/ACHPaymentOptionForm';
// NOTE: disabled check payout LB-1758
// import { RegularCheckPaymentOptionForm } from 'src/components/settings/RegularCheckPaymentOptionForm';
import { PAYMENT_METHODS } from 'src/constants/payments';
import { useTranslation } from 'react-i18next';
import { useStore } from 'src/stores';
import useStyles from './styles';
import { useFormik } from 'formik';
import HelpCenterButton from 'src/components/shared/HelpCenterButton';
import { propertyPayoutDetailsValidationScheme } from 'src/utils/formValidation/AddNewProperty';
export default function ModalForm(_ref) {
  var _payoutData, _payoutData2, _payoutData3, _payoutData4, _payoutData5, _payoutData6, _payoutData7, _payoutData8, _payoutData9, _payoutData0, _payoutData1, _payoutData10;
  let handleModalClose = _ref.handleModalClose,
    payoutData = _ref.payoutData,
    propertyId = _ref.propertyId,
    triggerReload = _ref.triggerReload;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const _useState = useState((_payoutData = payoutData["".concat(PAYMENT_METHODS.ACH)]) !== null && _payoutData !== void 0 && _payoutData.isPrimary ? PAYMENT_METHODS.ACH : (_payoutData2 = payoutData["".concat(PAYMENT_METHODS.RegularCheck)]) !== null && _payoutData2 !== void 0 && _payoutData2.isPrimary ? PAYMENT_METHODS.RegularCheck : PAYMENT_METHODS.ACH),
    _useState2 = _slicedToArray(_useState, 2),
    paymentMethodExt = _useState2[0],
    setPaymentMethod = _useState2[1];
  const classes = useStyles();
  const sendPayoutData = async _ref2 => {
    let nameOnAccount = _ref2.nameOnAccount,
      depositoryName = _ref2.depositoryName,
      routingNumber = _ref2.routingNumber,
      accountNumber = _ref2.accountNumber,
      achDepositDataPaymentId = _ref2.achDepositDataPaymentId,
      payeeName = _ref2.payeeName,
      payeeAddress = _ref2.payeeAddress,
      regularCheckPaymentId = _ref2.regularCheckPaymentId,
      paymentMethod = _ref2.paymentMethod;
    try {
      if (nameOnAccount && depositoryName && routingNumber && accountNumber) {
        const reqData = {
          propertyId,
          nameOnAccount,
          depositoryName,
          routingNumber,
          accountNumber,
          isPrimary: paymentMethod === PAYMENT_METHODS.ACH,
          id: achDepositDataPaymentId
        };
        const response = achDepositDataPaymentId ? await store.payment.putPayoutAchDirectDepositAsync.run(reqData) : await store.payment.postPayoutAchDirectDepositAsync.run(reqData);
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        !!(response !== null && response !== void 0 && response.isSuccessful) && toast('success', {
          body: ['Successfully updated ACH Direct Deposit data']
        });
      }
      if (payeeName && payeeAddress) {
        const reqData = {
          propertyId,
          payeeName,
          payeeAddress,
          isPrimary: paymentMethod === PAYMENT_METHODS.RegularCheck,
          id: regularCheckPaymentId
        };
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const response = regularCheckPaymentId ? await store.payment.putPayoutRegularCheckAsync.run(reqData) : await store.payment.postPayoutRegularCheckAsync.run(reqData);
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        // !!response?.isSuccessful &&
        //   toast('success', { body: ['Successfully updated Regular Check data'] });
      }
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      handleModalClose();
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      triggerReload();
    } catch (e) {
      console.log('Error', e);
    }
  };
  const formik = useFormik({
    initialValues: {
      paymentMethod: (_payoutData3 = payoutData["".concat(PAYMENT_METHODS.ACH)]) !== null && _payoutData3 !== void 0 && _payoutData3.isPrimary ? PAYMENT_METHODS.ACH : (_payoutData4 = payoutData["".concat(PAYMENT_METHODS.RegularCheck)]) !== null && _payoutData4 !== void 0 && _payoutData4.isPrimary ? PAYMENT_METHODS.RegularCheck : PAYMENT_METHODS.ACH,
      achDepositDataPaymentId: (_payoutData5 = payoutData["".concat(PAYMENT_METHODS.ACH)]) === null || _payoutData5 === void 0 ? void 0 : _payoutData5.id,
      nameOnAccount: (_payoutData6 = payoutData["".concat(PAYMENT_METHODS.ACH)]) === null || _payoutData6 === void 0 ? void 0 : _payoutData6.nameOnAccount,
      depositoryName: (_payoutData7 = payoutData["".concat(PAYMENT_METHODS.ACH)]) === null || _payoutData7 === void 0 ? void 0 : _payoutData7.depositoryName,
      routingNumber: (_payoutData8 = payoutData["".concat(PAYMENT_METHODS.ACH)]) === null || _payoutData8 === void 0 ? void 0 : _payoutData8.routingNumber,
      accountNumber: (_payoutData9 = payoutData["".concat(PAYMENT_METHODS.ACH)]) === null || _payoutData9 === void 0 ? void 0 : _payoutData9.accountNumber,
      regularCheckPaymentId: (_payoutData0 = payoutData["".concat(PAYMENT_METHODS.RegularCheck)]) === null || _payoutData0 === void 0 ? void 0 : _payoutData0.id,
      payeeName: (_payoutData1 = payoutData["".concat(PAYMENT_METHODS.RegularCheck)]) === null || _payoutData1 === void 0 ? void 0 : _payoutData1.payeeName,
      payeeAddress: (_payoutData10 = payoutData["".concat(PAYMENT_METHODS.RegularCheck)]) === null || _payoutData10 === void 0 ? void 0 : _payoutData10.payeeAddress
    },
    validationSchema: propertyPayoutDetailsValidationScheme,
    onSubmit: async values => {
      await sendPayoutData(values);
    }
  });
  const handlePrimaryPaymentMethodChange = async value => {
    if (value) {
      await formik.setFieldValue('paymentMethod', value);
      setPaymentMethod(value);
    }
  };
  return /*#__PURE__*/React.createElement("form", {
    id: 'update_property_payout_details' + propertyId,
    onSubmit: formik.handleSubmit
  }, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.payment.putPayoutAchDirectDepositAsync.inProgress || store.payment.putPayoutRegularCheckAsync.inProgress
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.formsWrapper
  }, /*#__PURE__*/React.createElement(HelpCenterButton, {
    topic: "reimbursement"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(ACHPaymentOptionForm, {
    editMode: true,
    formik: formik,
    handlePrimaryPaymentMethodChange: handlePrimaryPaymentMethodChange
  }))), /*#__PURE__*/React.createElement(Alert, {
    severity: "info",
    icon: false,
    size: "small"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('add_new_property_flow.authorization_details')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('add_new_property_flow.authorization_text'))));
}